const k12Scene = {
  public: {
    school: '学校',
    grade: '年级',
    group: '班级',
    student: '学生'
  },
  main: {
    nutritionMonitor: '学生营养监测',
    classManage: '班级管理'
  },
  system: {
    classManage: '班级管理',
    leader: '负责老师',
    teacher: '教师'
  },
  nutritionMonitor: {
    classTeacher: '班主任',
    number: '学号'
  }
}

const unitScene = {
  public: {
    school: '子机构',
    grade: '部门',
    group: '子部门',
    student: '职员'
  },
  main: {
    nutritionMonitor: '营养监测',
    classManage: '部门管理'
  },
  system: {
    classManage: '部门管理',
    leader: '负责人',
    teacher: '职员'
  },
  nutritionMonitor: {
    classTeacher: '负责人',
    number: '工号'
  }
}

export {
  k12Scene,
  unitScene
}
